import React from 'react';
import { InputField } from 'components/form';
import { useFormContext } from 'react-hook-form';

export const InventoryTableFilters = () => {
  const { control, setValue } = useFormContext();

  const handleVinOrStockNumberChange = (value: string) => {
    setValue('filters', {
      vin: value,
      stockId: value,
      make: [value],
      model: [value],
      yearTo: parseInt(value, 10) ? parseInt(value, 10) : undefined,
      yearFrom: parseInt(value, 10) ? parseInt(value, 10) : undefined,
    });
  };

  return (
    <InputField
      control={control}
      name="filters.vin"
      label="Vin, Stock Number, Year/Make/Model"
      extraAction={{ cb: handleVinOrStockNumberChange }}
      inputProps={{
        variant: 'outlined',
      }}
    />
  );
};
